import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientHelper } from '../../../../../appServices/apiClient';

const MENTOR_ANNOUNCEMENTS_URL = 'mentor_hub_announcements';
const DEFAULT_MESSAGE_URL = `${MENTOR_ANNOUNCEMENTS_URL}/default_message`;

@Injectable({ providedIn: 'root' })
export class MentorAnnouncementService {
    private readonly http = inject(HttpClientHelper);

    getAnnouncements(): Observable<unknown> {
        return this.http.get(MENTOR_ANNOUNCEMENTS_URL, 'admin');
    }

    createAnnouncement(payload: unknown): Observable<unknown> {
        return this.http.post(MENTOR_ANNOUNCEMENTS_URL, payload, 'admin');
    }

    updateAnnouncement(id: string, payload: unknown): Observable<unknown> {
        return this.http.patch(`${MENTOR_ANNOUNCEMENTS_URL}/${id}`, payload, 'admin');
    }

    updateDefaultMessage(payload: unknown): Observable<unknown> {
        return this.http.patch(DEFAULT_MESSAGE_URL, payload, 'admin');
    }

    deleteAnnouncement(id: string): Observable<unknown> {
        return this.http.delete(`${MENTOR_ANNOUNCEMENTS_URL}/${id}`, 'admin');
    }
}
